import LangEnum from '../lang/LangEnum';
import { useTranslation } from '../modules/translation/TranslationContext';
import snackbarStore from '../stores/Snackbar.store';

export const useCustomerUnauthorizedMessages = () => {
  const { translate } = useTranslation();
  const { handleMessage } = snackbarStore;

  const showUnauthorizedToCopyOrderProducts = () => {
    handleMessage({
      type: 'error',
      message: translate(LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_TO_COPY_ORDER_PRODUCTS),
    });
  };

  const showUnauthorizedOrderProducts = () => {
    handleMessage({
      type: 'error',
      message: translate(LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_ORDER_PRODUCTS),
    });
  };

  const showUnauthorizedProduct = () => {
    handleMessage({
      type: 'error',
      message: translate(LangEnum.API_EXCEPTION_CUSTOMER_UNAUTHORIZED_PRODUCT),
    });
  };

  return {
    showUnauthorizedToCopyOrderProducts,
    showUnauthorizedOrderProducts,
    showUnauthorizedProduct,
  };
};
